var Fancybox = (function () {
  var dialog = null;
  var currentIndex = 0;
  var items = [];
  var onLoadCb = null;
  var onDoneCb = null;

  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'yv-lightbox';
    dialog.innerHTML =
      '<div class="yv-lightbox-backdrop"></div>' +
      '<button class="yv-lightbox-close" aria-label="Close">&times;</button>' +
      '<button class="yv-lightbox-prev" aria-label="Previous">&#8249;</button>' +
      '<button class="yv-lightbox-next" aria-label="Next">&#8250;</button>' +
      '<div class="yv-lightbox-content"></div>' +
      '<div class="yv-lightbox-thumbs"></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.yv-lightbox-close').addEventListener('click', close);
    dialog.querySelector('.yv-lightbox-backdrop').addEventListener('click', close);
    dialog.querySelector('.yv-lightbox-prev').addEventListener('click', function () { show(currentIndex - 1); });
    dialog.querySelector('.yv-lightbox-next').addEventListener('click', function () { show(currentIndex + 1); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIndex - 1);
      if (e.key === 'ArrowRight') show(currentIndex + 1);
    });
    return dialog;
  }

  function show(index) {
    if (index < 0 || index >= items.length) return;
    currentIndex = index;
    var d = getDialog();
    var content = d.querySelector('.yv-lightbox-content');
    var item = items[index];
    var src = item.src || item.href || '';
    if (src.match(/youtube\.com|youtu\.be|vimeo\.com/)) {
      var embedUrl = src;
      if (src.match(/youtu\.?be/)) {
        var vid = src.match(/(?:v=|\/)([\w-]{11})/);
        if (vid) embedUrl = 'https://www.youtube.com/embed/' + vid[1] + '?autoplay=1';
      } else if (src.match(/vimeo/)) {
        var vmid = src.match(/vimeo\.com\/(\d+)/);
        if (vmid) embedUrl = 'https://player.vimeo.com/video/' + vmid[1] + '?autoplay=1';
      }
      content.innerHTML = '<iframe class="yv-lightbox-iframe" src="' + embedUrl + '" allowfullscreen allow="autoplay"></iframe>';
    } else {
      content.innerHTML = '<img class="yv-lightbox-img" src="' + src + '" alt="">';
    }
    d.querySelector('.yv-lightbox-prev').style.display = items.length > 1 ? '' : 'none';
    d.querySelector('.yv-lightbox-next').style.display = items.length > 1 ? '' : 'none';
    var thumbs = d.querySelector('.yv-lightbox-thumbs');
    if (items.length > 1 && items[0].thumb) {
      thumbs.innerHTML = items.map(function (it, i) {
        return '<img class="yv-lightbox-thumb' + (i === index ? ' active' : '') + '" src="' + (it.thumb || it.src) + '" data-index="' + i + '">';
      }).join('');
      thumbs.style.display = '';
      thumbs.querySelectorAll('.yv-lightbox-thumb').forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(this.dataset.index)); });
      });
    } else {
      thumbs.style.display = 'none';
    }
    if (onLoadCb) onLoadCb(null, { index: index });
    if (onDoneCb) onDoneCb(null, { index: index });
  }

  function close() {
    if (dialog && dialog.open) {
      var content = dialog.querySelector('.yv-lightbox-content');
      content.innerHTML = '';
      dialog.close();
      document.body.style.overflow = '';
      document.documentElement.classList.remove('with-fancybox');
      document.querySelectorAll('.yv-youtube-video').forEach(function (v) {
        v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      document.querySelectorAll('video').forEach(function (v) { v.pause(); });
    }
  }

  function open(galleryItems, opts) {
    opts = opts || {};
    items = galleryItems || [];
    currentIndex = 0;
    onLoadCb = (opts.on && opts.on.load) || null;
    onDoneCb = (opts.on && opts.on.done) || null;
    var d = getDialog();
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('with-fancybox');
    if (opts.mainClass) d.className = 'yv-lightbox ' + opts.mainClass;
    d.showModal();
    show(0);
  }

  function bind(selector, opts) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(selector);
      if (!trigger) return;
      e.preventDefault();
      onLoadCb = (opts && opts.on && opts.on.load) || null;
      onDoneCb = (opts && opts.on && opts.on.done) || null;
      var group = trigger.getAttribute('data-fancybox');
      var allInGroup = group && group !== 'none'
        ? Array.from(document.querySelectorAll('[data-fancybox="' + group + '"]'))
        : [trigger];
      items = allInGroup.map(function (el) {
        return { src: el.getAttribute('href') || el.dataset.src, thumb: el.dataset.thumb };
      });
      currentIndex = allInGroup.indexOf(trigger);
      if (currentIndex < 0) currentIndex = 0;
      var d = getDialog();
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('with-fancybox');
      d.showModal();
      show(currentIndex);
    });
  }

  open.bind = bind;
  return open;
})();
